import type { PageStateType } from '@confluence/page-context';

export type ContentType = PageStateType['contentType'];

export const isPageOrBlogPost = (contentType: ContentType) => {
	return contentType === 'page' || contentType === 'blogpost';
};
